import {
  TRADATHON_CREATE_ROOM,
  TRADATHON_CREATE_ROOM_ERROR,
  GET_LIVE_CONTESTS,
  SET_ACTIVE_ROOM,
  TRADATHON_ADD_COINS,
  TRADATHON_GET_COINS,
  TOGGLE_TRADATHON_ALERT_MODAL,
  SET_COIN_CST_AMOUNT,
  TRADATHON_EDIT_COINS,
  TRADATHON_SET_ACTIVE_CRYPTO_IN_VT,
  TRADATHON_CLEAR_COINS_DATA,
  TRADATHON_PLACE_ORDER_IN_VT,
  TRADATHON_PLACE_SELL_ORDER,
  TRADATHON_PLACE_ORDER_IN_VT_ERROR,
  TRADATHON_SET_ALREADY_INVESTED,
  TRADATHON_GET_PARTICULAR_PORTFOLIO_IN_VT,
  TRADATHON_SET_ACTIVE_PORTFOLIO_ID_IN_MODAL_IN_VT,
  TRADATHON_SET_SELL_TYPE_IN_VT,
  TRADATHON_SET_ACTIVE_PRICE,
  TRADATHON_GET_COINS_IN_PARTICULAR_PORTFOLIO_IN_VT,
  TRADATHON_MODIFY_ORDER_IN_VT,
  TRADATHON_CANCEL_ORDER_IN_VT,
  TRADATHON_SET_SELL_PRICE_FOR_STOP_LIMIT,
  TRADATHON_FILTER_PORTID_IN_GET_USER_POSITION_IN_VT,
  TRADATHON_GET_LIVE_CONTEST_COINS,
  GET_LEADERBOARD_OF_CONTEST,
  TRADATHON_SET_TOTAL_CURRENT_AMOUNT,
  TRADATHON_SET_NET_PL,
  TRADATHON_SET_TOTAL_INV_AMOUNT,
  PAY_FOR_TRADATHON,
  CLEAR_ROOM_DATA,
  CLEAR_TRADATHON_ERROR,
  CLEAR_TRADATHON_MESSAGE,
  START_TRADATHON_LOADING,
  STOP_TRADATHON_LOADING,
  GET_WINNINGS,
  CLEAR_LEADERBOARD,
  TRADATHON_DELETE_COINS,
  CHANGE_BALANCE,
  TRADATHON_CLEAR_CONTESTS,
  TRADATHON_CLEAR_WINNINGS,
  GET_ROOM,
  START_TRADATHON_ROOM_LOADING,
  STOP_TRADATHON_ROOM_LOADING,
  CHECK_USER_JOINED,GET_WINNINGS_DISTRIBUTION,SET_USER_JOINED,
  START_JOINING,STOP_JOINING
} from "../types";
import { toast } from "react-toastify";
const TradathonReducer = (state, action) => {
  switch (action.type) {
    case TRADATHON_SET_TOTAL_CURRENT_AMOUNT:
      return { ...state, tradathon_currentAmount: action.payload };
    case TRADATHON_SET_TOTAL_INV_AMOUNT:
      return { ...state, tradathon_invAmount: action.payload };
    case TRADATHON_SET_NET_PL:
      return { ...state, tradathon_netPL: action.payload };
    case TRADATHON_CREATE_ROOM:
      action.from === "join"
        ? toast.success("Joined Room Successfully", {
            position: "top-right",
            autoClose: 6000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          })
        : toast.success(action.payload, {
            position: "top-right",
            autoClose: 6000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
      return {
        ...state,
        createRoomData: action.payload,
        activeRoom: {
          ...action.payload.data.roomMember,
          room: action.payload.data.roomData,
        },
      };
    case TRADATHON_CREATE_ROOM_ERROR:
      action.from === "publicContestModal"
        ? toast.error(action.payload, { autoClose: 5000 })
        : toast.error(action.payload[0].msg, {
            position: "top-right",
            autoClose: 6000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
      return { ...state, createRoomData: action.payload };
    case TRADATHON_DELETE_COINS:
      toast.error("💰 Deleted Coin Successfully", {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return { ...state };
    case TRADATHON_CLEAR_CONTESTS:
      return { ...state, contests: null };
    case GET_ROOM:
      return { ...state, roomDetails: action.payload.data };
    case CHANGE_BALANCE:
      return {
        ...state,
        activeRoom: {
          ...state.activeRoom,
          balance: action.payload + state.activeRoom.balance,
        },
      };
    case GET_LIVE_CONTESTS:
      let activeRoom;
      if (state.activeRoom) {
        // console.log(state.activeRoom);
        activeRoom = action.payload?.data?.filter(
          (d) => d.rid === state.activeRoom.rid
        )[0];
        // console.log(activeRoom);
        if (activeRoom) {
          localStorage.setItem("activeRoom", JSON.stringify(activeRoom));
        }
      }

      return {
        ...state,
        contests: action.contestType !== "upcoming" && action.payload,
        publicContests: action.contestType === "upcoming" && action.payload,
        activeRoom: state.activeRoom ? activeRoom : state.activeRoom,
      };

    case SET_ACTIVE_ROOM:
      localStorage.setItem("activeRoom", JSON.stringify(action.payload));
      return { ...state, activeRoom: action.payload };
    case PAY_FOR_TRADATHON:
      localStorage.setItem(
        "activeRoom",
        JSON.stringify({ ...state.activeRoom, isPaid: true })
      );
      return { ...state, activeRoom: { ...state.activeRoom, isPaid: true } };
    case TRADATHON_ADD_COINS:
      toast.success("💰 added coin successfully", {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return { ...state };
    case TRADATHON_GET_COINS:
      if (state.activeRoom.room.rstatus === 1) {
      }

      return {
        ...state,
        coins: action.payload.data?.coins,
        activeRoom:
          state.activeRoom.room.rstatus === 1
            ? action.payload.data &&
              action.payload.data.roomMember && {
                ...state.activeRoom,
                balance:
                  action.payload.data.roomMember.balance -
                  action.payload.data.roomMember.lockAmount,
                lockAmount: action.payload.data.roomMember.lockAmount,
              }
            : state.activeRoom.room.rstatus === 0
            ? action.payload.data &&
              action.payload.data.roomMember && {
                ...state.activeRoom,
                balance:
                  action.payload.data.roomMember.balance -
                  action.payload.data.roomMember.lockAmount,
                lockAmount: action.payload.data.roomMember.lockAmount,
              }
            : state.activeRoom,
      };
    case TOGGLE_TRADATHON_ALERT_MODAL:
      return { ...state, tradathonModal: !state.tradathonModal };
    case SET_COIN_CST_AMOUNT:
      return { ...state, coinCSTAmount: action.payload };
    case TRADATHON_SET_ACTIVE_CRYPTO_IN_VT:
      localStorage.setItem(
        "tradathonActiveItemForSell",
        JSON.stringify(action.payload)
      );
      return {
        ...state,
        tradathon_activeCrypto: action.payload,
      };
    case TRADATHON_CLEAR_COINS_DATA:
      return { ...state, tradathon_coinsData: null };
    case TRADATHON_PLACE_ORDER_IN_VT:
      action.show
        ? toast.success("💰 Placed Order Successfully", {
            position: "top-right",
            autoClose: 6000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          })
        : toast.success("💰 Modified Order Successfully", {
            position: "top-right",
            autoClose: 6000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
      return {
        ...state,
        tradathon_orderDetails: action.payload,
        tradathon_vtradingMessage: "Placed order Successfully",
      };
    case TRADATHON_PLACE_SELL_ORDER:
      toast.error("💰 Sold order Successfully", {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return {
        ...state,
        tradathon_orderDetails: action.payload,
        tradathon_sellPrice: null,
        tradathon_vtradingError: "Sold order Successfully",
      };
    case TRADATHON_PLACE_ORDER_IN_VT_ERROR:
      toast.error(`💰 ${action.payload}`, {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return { ...state, tradathon_vtradingError: action.payload };
    case START_TRADATHON_ROOM_LOADING:
      return { ...state, tradathonRoomLoading: true };
    case STOP_TRADATHON_ROOM_LOADING:
      return { ...state, tradathonRoomLoading: false };
    case TRADATHON_SET_ALREADY_INVESTED:
      let a;
      if (state.count === 0) {
        a = action.payload.data.map((i, index) => {
          return {
            [index]: i.openOrders && i.openOrders.length > 0 ? true : false,
          };
        });
      }
      return {
        ...state,
        tradathon_alreadyInvested:
          state.count === 0 ? a : state.alreadyInvested,
        tradathon_count: state.count + 1,
      };
    case TRADATHON_GET_PARTICULAR_PORTFOLIO_IN_VT:
      return {
        ...state,
        tradathon_singlePortfolio: action.payload,
        tradathon_PCSTAmount: action.payload.data[0].curramount,
        tradathon_portId: action.payload.data[0]._id,
      };
    case TRADATHON_SET_ACTIVE_PORTFOLIO_ID_IN_MODAL_IN_VT:
      return { ...state, tradathon_activePortID: action.payload };
    case TRADATHON_SET_SELL_TYPE_IN_VT:
      return { ...state, tradathon_orderType: action.payload };
    case TRADATHON_GET_COINS_IN_PARTICULAR_PORTFOLIO_IN_VT:
      return { ...state, tradathon_coinsData: action.payload.data };
    case TRADATHON_FILTER_PORTID_IN_GET_USER_POSITION_IN_VT:
      return {
        ...state,
        tradathon_currentPortIDDetails: state.coinsData
          ? state.coinsData.filter((i, index) => i._id === state.portId)
          : null,
      };
    case TRADATHON_SET_ACTIVE_PRICE:
      return { ...state, tradathon_activePrice: action.payload };

    case TRADATHON_SET_SELL_PRICE_FOR_STOP_LIMIT:
      return { ...state, tradathon_sellPrice: action.payload };
    case TRADATHON_CANCEL_ORDER_IN_VT:
      action.show &&
        toast.error("💰 Cancelled order Successfully", {
          position: "top-right",
          autoClose: 6000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

      return {
        ...state,

        tradathon_orderDetails: action.payload,

        //   tradathon_vtradingError: "Cancelled order Successfully",
      };
    case TRADATHON_MODIFY_ORDER_IN_VT:
      toast.success("💰 Modified order Successfully", {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return {
        ...state,
        tradathon_orderDetails: action.payload,
        tradathon_activePrice: { ...state.activePrice, orderId: null },
        tradathon_vtradingMessage: "Modified order Successfully",
      };
    case TRADATHON_EDIT_COINS:
      toast.success("💰 Edited Successfully", {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return { ...state };
    case TRADATHON_GET_LIVE_CONTEST_COINS:
      // historyCoins:action.vtButton==="history"&& action.payload.data,openOrderCoins:action.vtButton==="openOrder"&&action.payload.data
      return { ...state, coins: action.payload.data, createRoomData: null };
    case GET_LEADERBOARD_OF_CONTEST:
      return { ...state, leaderboard: action.payload };
    case CLEAR_ROOM_DATA:
      return { ...state, createRoomData: null };
    case CLEAR_TRADATHON_MESSAGE:
      return { ...state, tradathon_vtradingMessage: null };
    case CLEAR_TRADATHON_ERROR:
      return { ...state, tradathon_vtradingError: null };

    case START_TRADATHON_LOADING:
      return {
        ...state,
        tradathonLoading: true,
      };
    case STOP_TRADATHON_LOADING:
      return { ...state, tradathonLoading: false };
    case GET_WINNINGS:
      return { ...state, winnings: action.payload.data };
    case CLEAR_LEADERBOARD:
      return { ...state, leaderboard: null };
    case TRADATHON_CLEAR_WINNINGS:
      return { ...state, winnings: null };
      case CHECK_USER_JOINED:
        console.log(action.payload)
        console.log(action.payload&&action.payload.data&&action.payload.data.length===0?false:true)
        return {...state,joinedRoom:action.payload&&action.payload.data&&action.payload.data.length===0?false:true}
        case GET_WINNINGS_DISTRIBUTION:
          return {...state,winnings: action.payload.data}
          case SET_USER_JOINED:
            return {...state,joinedRoom: false}
            case START_JOINING:
              return {...state,
                joiningLoading:true}
                case STOP_JOINING:
              return {...state,
                joiningLoading:false}
    default:
      return { ...state };
  }
};

export default TradathonReducer;
